import { useTranslation } from 'react-i18next'
import { Truck, Clock, ShieldCheck, ArrowRight } from 'lucide-react'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { LocalizedLink } from '../LocalizedLink'

const benefits = [
  { key: 'consultancy', icon: Truck },
  { key: 'response', icon: Clock },
  { key: 'certified', icon: ShieldCheck },
] as const

export function QuoteCTA() {
  const { t } = useTranslation('common')

  return (
    <Section variant="dark">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <SectionTitle
              title={t('home.quote.title')}
              subtitle={t('home.quote.subtitle')}
              light
            />

            <ul className="space-y-4 mb-10">
              {benefits.map((benefit) => (
                <li key={benefit.key} className="flex items-center gap-3 text-white/85">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-red/20">
                    <benefit.icon className="w-5 h-5 text-brand-red" />
                  </span>
                  <span className="text-base md:text-lg">
                    {t(`home.quote.benefits.${benefit.key}`)}
                  </span>
                </li>
              ))}
            </ul>

            <LocalizedLink
              to="contacts"
              className="group inline-flex items-center gap-2 bg-brand-red text-white px-8 py-3 rounded-lg font-medium hover:bg-brand-red-dark transition-colors"
            >
              {t('buttons.contactUs')}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </LocalizedLink>
          </div>

          <div className="hidden lg:block">
            <div className="group relative aspect-video rounded-xl overflow-hidden border border-white/10">
              <img
                src="/images/chiggiato-logo-truck.jpg"
                alt={t('home.quote.imageAlt')}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-normal"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-brand-dark/40 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  )
}
